import React, { useState } from 'react';
import { PatientPicker } from '../../CustomControls/PatientPicker';
import { Button, Col, ControlLabel, FormGroup, Grid, Modal, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { CustomSelect } from '../../CustomControls/CustomSelect';
import { Add, Save } from '../../Icons/Icons';
import { ModalData } from '../../Modals/ModalData';
import { CustomSearchBox } from '../../CustomControls/CustomSearchBox';

const AddPatients = ({ confirmPatients, addPatients, selectedPatients, groupPatientLimit, currentPatientCount }) => {
    const { t } = useTranslation();
    const [isShowing, setIsShowing] = useState(false);

    // groupPatientLimit <= 0 se trata como "sin límite configurado" -- mismo criterio que el backend
    // (GroupsService.AddPatients), para no bloquear para siempre un grupo cuyo límite nunca se configuró.
    const wouldExceedLimit = groupPatientLimit > 0
        && (currentPatientCount ?? 0) + selectedPatients.length > groupPatientLimit;

    return (
        <>
            <div className="col-md-3">
                <button type="button" className="btn btn-primary" onClick={() => { setIsShowing(true) }} ><Add />{t("buttons.add")}</button >
            </div>
            <ModalData
                isShowing={isShowing}
                hide={() => setIsShowing(false)}
                title={t('protocols.groups.addPatient')}
                size="medium"
                className=""
                footer={
                    <>
                        <Button type="button" className="btn " onClick={() => setIsShowing(false)} >{t("buttons.cancel")}</Button>
                        <Button type="submit" className="btn btn-success btn-primary" onClick={confirmPatients} disabled={selectedPatients.length === 0 || wouldExceedLimit}>
                            <Save />{t("buttons.save")}
                        </Button>
                    </>
                }
            >
                <div>
                    <FormGroup>
                        <ControlLabel>{t('protocols.groups.patients')}</ControlLabel>
                        <PatientPicker
                            autoFocus
                            id="agenda-patient-picker"
                            name="patient"
                            multiple={true}
                            placeholder={t('protocols.groups.patient')}
                            onChange={addPatients}
                            //value={selectedPatient}
                            selected={selectedPatients}
                        />
                        {wouldExceedLimit &&
                            <small className="text-danger">{t('protocols.groups.patientLimitExceeded', { limit: groupPatientLimit })}</small>
                        }
                    </FormGroup>
                </div>

            </ModalData>
        </>

    );
};

export default AddPatients;